/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { useAppSelector } from 'store/hooks'

import CartItems from 'containers/shop/cart/cartItems'
import CartSummary from 'containers/shop/cart/cartSummary'
import CartEmpty from 'containers/shop/cart/cartEmpty'

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function CartForm() {
    const { cart } = useAppSelector((state) => state.shop)

    if (!cart?.uuid) {
        return (
            <StyledCartForm>
                <CartEmpty/>
            </StyledCartForm>
        )
    }

    return (
        <StyledCartForm>
            <CartItems/>
            <CartSummary/>
        </StyledCartForm>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const StyledCartForm = styled.div`
    display: grid;
    gap: 20px;
`
